import React, { useEffect, useState } from "react";
import Select from "react-select";
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';
import PlusIcon from "Ecommerce/template_three/assets/icons/PlusIcon";
import MinusIcon from "Ecommerce/template_three/assets/icons/MinusIcon";
import { Nationality } from "pos/common/module/nationalityarray";
import { _Api, _Apiauth } from "Ecommerce/common/api";
import EditIcon from "Ecommerce/template_three/assets/icons/EditIcon";
import ConfirmPage from "./ConfirmPage";
import OrderSummery from "./OrderSummery";
import './shipping.scss';
import DefaultImage from "Ecommerce/common/images/emptyCart.png"
import CheckoutBucketIcon from "Ecommerce/common/icons/CheckoutBucketIcon";
import DownArrow from "Ecommerce/template_three/assets/icons/DownArrow";
import { toFormatPrice } from "Ecommerce/common/Formateprice";
import RightArrow from "admin/common/icons/right-arrow";
import PaymentTabs from "../PaymentGateway/PaymentTabs";
import LeftIcon from "admin/common/icons/sidebar/LeftIcon";
import GreenTick from "admin/common/icons/GreenTick";

export default function Shipping(props) {

    const { t } = useTranslation();
    const accessToken = localStorage.getItem("ecomaccesstoken");
    const navigate = useNavigate();
    const [privacyPolicy, setPrivacyPolicy] = useState(false);
    const [copytoShipping, setCopytoShipping] = useState(false);
    const [activeAddress, setActiveAddress] = useState({ billing: null, shipping: null })
    let cartdata = JSON.parse(localStorage.getItem('CartItems'))
    const { setOpenmodal } = props;
    // eslint-disable-next-line
    const [nationalityoption, setNationalityoption] = useState()
    useEffect(() => {
        if (Nationality?.length) {
            let Nationalitydata = []
            Nationality.forEach((result) => {
                Nationalitydata.push({ value: result, label: result })
            })
            setNationalityoption(Nationalitydata)
        }
        getaddress();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const { state } = useLocation()

    const [userdata, setUserdata] = useState({
        shipping_address: {
            'fname': '',
            'lname': '',
            'nationality': '',
            'title': '',
            'govt_ids': [{ 'idtype': '', 'idnumber': '' }],
            'age': '',
            "contacts": [{ icon: 1, phoneCode: "", number: "" }],
            'gender': '',
            'address': '',
            'country': '',
            'state': '',
            'city': '',
            'zipcode': '',
            'emails': [""],
            "is_default": 0
        },
        'default_billing': false,
        'agree': 0,
        'shipping_method': { 'shiptohome': '', 'storepick': '' },
        'billingaddress': {
            'fname': '', 'lname': '', 'address': '', 'country': '', 'state': '', 'city': '', 'zipcode': '',
            'contacts': [{ icon: 1, phoneCode: "", number: "" }], 'emails': [""],
            "is_default": 0
        }
    });
// eslint-disable-next-line
    const [dobvalues, setDobvalues] = useState({ date: [], month: [], year: [] })
    const [fromstaps, setFromstaps] = useState({ one: true, two: false, three: false })
    const [countrylist, setCountrylist] = useState([]);
    const [phonecodelist, setPhonecodelist] = useState([]);
    const [changeshipping, setChangeshipping] = useState(true);
    const [shippingmethod, setShippingmethod] = useState();
    const [errormessage, setErrormessage] = useState();
    const [shippinglist, setShippinglist] = useState([])
    const [shippingdata, setShippingdata] = useState();
    const [addNewAddress, setAddNewAddress] = useState('');
    const [fromshow, setFromshow] = useState(true)
    // eslint-disable-next-line
    const [billingaddressfrom, setBillingaddress] = useState(false)
    const [paymentgetwaydata, setPaymentgetwaydata] = useState([])
    // eslint-disable-next-line
    const [paymentdata, setPaymentdata] = useState({ Bank: [], Credit_Card: [] })
    const [lodaer, setLodaer] = useState(false)
    const [widtth, setWidtth] = useState(window.innerWidth);
    const [addressdata, setAddressdata] = useState();

    const [billingaddressdata, setBillingaddressdata] = useState(
        {
            'contacts': [{ icon: 1, phoneCode: "", number: "" }],
            'emails': [],
            is_default: 0
        }

    )
    const [creditpaymentdata, setCreditpaymentdata] = useState({
        message: "",
        payment: false,
        submitdata: false,
        Paymentmethod_type: "",
        payment_slag: "",
        PaymentMethod_id: "",
        PaymentMethod: ""
    })
    const [lastpagedata, setLastpagedata] = useState();
    const [isOpenOrder, setIsOpenOrder] = useState(false);

    // get screen width
    useEffect(() => {
        const handleResize = () => {
            setWidtth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getaddress = async () => {
        if (accessToken) {
            try {
                let postdata = {}
                let res = await _Api(postdata, `account/getAddresses`)
                if (res?.statusCode === 200) {
                    setAddressdata(res?.data)
                    // setAddressdata([])
                }
            }
            catch (err) {
                console.log(err, "err")
            }
        }
    }


    const getFullAddress = async (UDID,billing = true) => {
        if(accessToken && UDID){
            try{
                let postdata = {
                    billing_address:billing,
                    id: UDID
                }
                let res = await _Api(postdata, `account/getAddressByID`)
                if (res?.statusCode === 200) {
                    // console.log('this is the billing address',billing,res)
                    // setUserdata((state) =>{ {...state , billingaddress:{...res?.data}}})
                    delete res?.data?.primary;
                  if(res?.data && billing){
                    setUserdata((state) => ({
                        ...state,
                        billingaddress: {
                            ...res?.data
                        }
                    }))}

                    if(res?.data && !billing){
                        setUserdata((state) => ({
                            ...state,
                            shipping_address: {
                                ...res?.data
                            }
                        }))}
                }
            }
            catch (err) {
                console.log(err, "err")
            }
        }
    }

    const toggleOrderSummary = () => {
        setIsOpenOrder(!isOpenOrder);
    };
    const shippingitem = async () => {
        try {
            let cartids = state?.checkoutItems;

            let postdata = {
                diamond_ids: cartids
            }
            // console.log(postdata, "Check cart ids")
            let res = await _Api(postdata, `order/getCartDetails`)
            if (res?.statusCode === 200) {
                if (res?.data) {
                    let array = [...res?.data];
                    array?.forEach((result) => {
                        result.qty = parseInt(state?.checkoutItems.filter(e => e?.id === result?.id)[0]['qty']);
                    })
                    setShippinglist(array)
                }

                setShippingdata((state) => ({
                    ...state,
                    CURRENCY: res?.CURRENCY
                }))
                if (res?.deleted_ids?.length) {
                    state?.checkoutItems.forEach((result) => {
                        if (!res?.deleted_ids.includes(result?.id)) {
                            let data = []
                            data.push(result)
                            localStorage.setItem('CartItems', JSON.stringify(data));
                        }
                    })
                }
            }
        }
        catch (err) {
            console.log(err, "Err")
        }
    }
    // eslint-disable-next-line
    const callAge = (e) => {
        const current = new Date();
        const year = current.getFullYear();
        const calage = year - e.value;
        setUserdata((state) => ({
            ...state,
            shipping_address: {
                ...state?.shipping_address,
                age: calage
            }
        }))
    };
// eslint-disable-next-line
    const titleoption = [
        {
            value: "Mr",
            label: t("Mr."),
        },
        {
            value: "Miss",
            label: t("Miss"),
        },
        {
            value: "Mrs",
            label: t("Mrs"),
        },
        {
            value: "Ms",
            label: t("Ms"),
        },
    ];

    useEffect(() => {
        if (state?.checkoutItems?.length) {
            shippingitem()
        }
        // eslint-disable-next-line
    }, [state])
// eslint-disable-next-line
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    try {
                        const postdata = {
                            image: reader.result,
                        };
                        let res = await _Api(postdata, `redis/uplaod`)
                        if (res.statusCode === 200) {
                            if (userdata?.paymentMethod?.IB) {
                                setUserdata({
                                    ...userdata,
                                    'paymentMethod': {
                                        ...userdata?.paymentMethod,
                                        IB: {
                                            ...userdata?.paymentMethod?.IB,
                                            image: res?.url
                                        }
                                    }
                                });
                            }
                            setErrormessage((state) => ({
                                ...state,
                                'bankimage': 'image is successfully upload'
                            }))
                        }
                    }
                    catch (err) {
                        console.log(err, "err")
                    }
                };
                if (file) {
                    reader?.readAsDataURL(file);
                }
            } else {
                alert("Please select a valid image file.");
            }
        }
    };
    const getuserdetails = async (monthoption) => {
        try {
            setErrormessage();
            let res = await _Api({}, `checkout/accountDetails`)
            if (res?.statusCode === 200) {
                if (res?.billingAddress) {
                    setBillingaddress(true)
                }
                setUserdata({
                    customer_id: res?.user?._id ? res?.user?._id : "",
                    shipping_address: {
                        fname: res?.shippingAddress?.fname ? res?.shippingAddress?.fname : res?.user?.fname,
                        mname: res?.shippingAddress?.mname ? res?.shippingAddress?.mname : res?.user?.mname,
                        lname: res?.shippingAddress?.lname ? res?.shippingAddress?.lname : res?.user?.lname,
                        nationality: res?.shippingAddress?.nationality,
                        title: res?.shippingAddress?.title,
                        govt_ids: res?.shippingAddress?.govt_ids?.length ? res?.shippingAddress?.govt_ids : [{ 'idtype': '', 'idnumber': '' }],
                        date_of_birth: {
                            date: res?.shippingAddress?.date_of_birth?.date,
                            month: monthoption.find(element => element?.value === res?.shippingAddress?.date_of_birth?.month), year: res?.shippingAddress?.date_of_birth?.year
                        },
                        age: res?.shippingAddress?.age,
                        gender: res?.shippingAddress?.gender,
                        address: res?.shippingAddress?.address,
                        country: res?.shippingAddress?.country ? res?.shippingAddress?.country : '',
                        state: res?.shippingAddress?.state,
                        city: res?.shippingAddress?.city,
                        zipcode: res?.shippingAddress?.zipcode,
                        contacts: res?.shippingAddress?.contacts?.length ? res?.shippingAddress?.contacts : [{ "icon": 1, "phoneCode": "", "number": "" }],
                        emails: res?.shippingAddress?.emails?.length ? res?.shippingAddress?.emails : [res?.user?.email],
                        UDID: res?.shippingAddress?.UDID,
                        is_default: res?.shippingAddress?.is_default ? res?.shippingAddress?.is_default : 0,
                    },
                    billingaddress: {
                        'fname': res?.billingAddress?.fname ? res?.billingAddress?.fname : res?.user?.fname,
                        'lname': res?.billingAddress?.lname ? res?.billingAddress?.lname : res?.user?.lname,
                        'address': res?.billingAddress?.address ? res?.billingAddress?.address : "",
                        'country': res?.billingAddress?.country ? res?.billingAddress?.country : "",
                        'state': res?.billingAddress?.state ? res?.billingAddress?.state : "",
                        'city': res?.billingAddress?.city ? res?.billingAddress?.city : "",
                        'zipcode': res?.billingAddress?.zipcode ? res?.billingAddress?.zipcode : "",
                        'contacts': res?.billingAddress?.contacts?.length ? res?.billingAddress?.contacts : [{ icon: 1, phoneCode: "", number: "" }],
                        'emails': res?.billingAddress?.emails?.length ? res?.billingAddress?.emails : [res?.user?.email],
                        "govt_ids": res?.billingAddress?.govt_ids,
                        "is_default": res?.billingAddress?.is_default ? res?.billingAddress?.is_default : 0,
                        "UDID": res?.billingAddress?.UDID,
                        "date_of_birth": res?.billingAddress?.date_of_birth
                    }
                })
                setBillingaddressdata({
                    'fname': res?.billingAddress?.fname ? res?.billingAddress?.fname : res?.user?.fname,
                    'lname': res?.billingAddress?.lname ? res?.billingAddress?.lname : res?.user?.lname,
                    'address': res?.billingAddress?.address,
                    'country': res?.billingAddress?.country,
                    'state': res?.billingAddress?.state,
                    'city': res?.billingAddress?.city,
                    'zipcode': res?.billingAddress?.zipcode,
                    'contacts': res?.billingAddress?.contacts?.length ? res?.billingAddress?.contacts : [{ icon: 1, phoneCode: "", number: "" }],
                    'emails': res?.billingAddress?.emails?.length ? res?.billingAddress?.emails : [res?.user?.email],
                    "govt_ids": res?.billingAddress?.govt_ids,
                    "is_default": res?.billingAddress?.is_default ? res?.billingAddress?.is_default : 0,
                    "UDID": res?.billingAddress?.UDID,
                    "date_of_birth": res?.billingAddress?.date_of_birth
                })
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const ChangeMultipleSelect = (first, key, label, second,forshipping=true) => {
        if(forshipping){
        if (label === 'govt_ids') {
            const ids = [...userdata?.shipping_address?.govt_ids];
            ids[key] = { 'idtype': first, 'idnumber': second }
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });
        }
        if (label === 'contacts') {
            const contacts = [...userdata?.shipping_address?.contacts];
            contacts[key] = { "icon": 1, 'phoneCode': first, 'number': second }
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });
        }
        if (label === 'email') {
            const email = [...userdata?.shipping_address?.emails];
            email[key] = first;
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });
        }
    }else{
        if (label === 'govt_ids') {
            const ids = [...userdata?.billingaddress?.govt_ids];
            ids[key] = { 'idtype': first, 'idnumber': second }
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });
        }
        if (label === 'contacts') {
            const contacts = [...userdata?.billingaddress?.contacts];
            contacts[key] = { "icon": 1, 'phoneCode': first, 'number': second }
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });
        }
        if (label === 'email') {
            const email = [...userdata?.billingaddress?.emails];
            email[key] = first;
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });
        }
    }
    }
    const AddRow = (element,forshipping=true) => {
        if(forshipping){
        if (element === 'govt_ids') {
            const ids = [...userdata?.shipping_address?.govt_ids];
            ids.push({ 'idtype': '', 'idnumber': '' });
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });

        }
        if (element === 'contacts') {
            const contacts = [...userdata?.shipping_address?.contacts];
            contacts.push({ "icon": 1, "phoneCode": "", "number": "" });
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });

        }
        if (element === 'email') {
            const email = [...userdata?.shipping_address?.emails];
            email.push('');
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });

        }
    }else{
        if (element === 'govt_ids') {
            const ids = [...userdata?.billingaddress?.govt_ids];
            ids.push({ 'idtype': '', 'idnumber': '' });
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });

        }
        if (element === 'contacts') {
            const contacts = [...userdata?.billingaddress?.contacts];
            contacts.push({ "icon": 1, "phoneCode": "", "number": "" });
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });

        }
        if (element === 'email') {
            const email = [...userdata?.billingaddress?.emails];
            email.push('');
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });

        }
    }
    }
    const RemoveBlock = (element, key,forshipping=true) => {
        if(forshipping){
        if (element === 'govt_ids') {
            let ids = [...userdata?.shipping_address?.govt_ids];
            ids = ids.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, govt_ids: ids } });

        }
        if (element === 'contacts') {
            let contacts = [...userdata?.shipping_address?.contacts];
            contacts = contacts.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, contacts: contacts } });
        }
        if (element === 'email') {
            let email = [...userdata?.shipping_address?.emails];
            email = email.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'shipping_address': { ...userdata?.shipping_address, emails: email } });
        }
    }else{
        if (element === 'govt_ids') {
            let ids = [...userdata?.billingaddress?.govt_ids];
            ids = ids.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, govt_ids: ids } });

        }
        if (element === 'contacts') {
            let contacts = [...userdata?.billingaddress?.contacts];
            contacts = contacts.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, contacts: contacts } });
        }
        if (element === 'email') {
            let email = [...userdata?.billingaddress?.emails];
            email = email.filter((e, s) => s !== key);
            setUserdata({ ...userdata, 'billingaddress': { ...userdata?.billingaddress, emails: email } });
        }
    }
    }
    const getcountry = async () => {
        try {
            let res = await _Apiauth({}, `redis/countryList`)
            if (res?.statusCode === 200) {
                if (res?.data) {
                    let array = [];
                    let phoncodearray = [];
                    res?.data.forEach((result) => {
                        array.push({ 'label': result?.name, 'value': result?.id });
                        phoncodearray.push({ 'label': result?.phoneCode, 'value': result?.phoneCode })
                    })
                    setCountrylist(array);
                    setPhonecodelist(phoncodearray);
                }

            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    const getshippings = async () => {
        try {
            let res = await _Apiauth({}, `redis/shipingMathod`)
            if (res?.statusCode === 200) {
                setShippingmethod({ shiptohome: res?.ShipToHome, storepickup: res?.StorePickup });
            } else {
                setShippingmethod({ shiptohome: [], storepickup: [] });
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    // eslint-disable-next-line
    const ChangeCheck = (label, e) => {
        if (label === 'agree') {
            if (e.target.checked) {
                setUserdata({ ...userdata, 'agree': 1 });
            } else {
                setUserdata({ ...userdata, 'agree': 0 });
            }
        }
        if (label === 'default_billing') {
            if (e.target.checked) {
                setUserdata({
                    ...userdata,
                    'billingaddress': userdata?.shipping_address,
                    default_billing: true
                });

            } else {
                setUserdata({
                    ...userdata,
                    'billingaddress': billingaddressdata,
                    default_billing: false
                });
            }
        }
    }
    const handleSelectAddress = (address, key) => {

        // console.log(activeAddress, "activ address")
        // setUserdata((state) => ({ ...state, billingaddress: address }));
        setActiveAddress((state) => ({ ...state, billing: key }))


    }
    const validationfun = (userdata) => {
        if (copytoShipping) {
            setUserdata((state) => ({ ...state, shipping_address: userdata?.billingaddress }));
        }
        let passval = true;

        if (!privacyPolicy) {
            setErrormessage((state) => ({
                ...state,
                'privacyPolicy': 'Please confirm Privacy Policy'
            }))
            passval = false;
        } else {
            setErrormessage((state) => ({
                ...state,
                'privacyPolicy': ''
            }))
        }
        if (!addressdata?.shipping_address?.length) {
            if (!userdata?.shipping_address?.fname) {
                setErrormessage((state) => ({
                    ...state,
                    'fname': 'First Name is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'fname': ''
                }))
            }
            if (!userdata?.shipping_address?.lname) {
                setErrormessage((state) => ({
                    ...state,
                    'lname': 'Last Name is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'lname': ''
                }))
            }

            if (!userdata?.shipping_address?.address) {
                setErrormessage((state) => ({
                    ...state,
                    'address': 'Address is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'address': ''
                }))
            }
            if (!userdata?.shipping_address?.country?.value) {
                setErrormessage((state) => ({
                    ...state,
                    'country': 'Country is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'country': ''
                }))
            }
            if (!userdata?.shipping_address?.state) {
                setErrormessage((state) => ({
                    ...state,
                    'state': 'State is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'state': ''
                }))
            }
            if (!userdata?.shipping_address?.city) {
                setErrormessage((state) => ({
                    ...state,
                    'city': 'City is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'city': ''
                }))
            }
            if (!userdata?.shipping_address?.zipcode) {
                setErrormessage((state) => ({
                    ...state,
                    'zipcode': 'Zipcode is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'zipcode': ''
                }))
            }
            if (!userdata?.shipping_address?.emails[0]) {
                setErrormessage((state) => ({
                    ...state,
                    'emails': 'Emails is required'
                }))
                passval = false;
            } else if (!isValidEmail(userdata?.shipping_address?.emails[0])) {
                setErrormessage((state) => ({
                    ...state,
                    'emails': 'Invalid Email'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'emails': ''
                }))
            }
            if (!userdata?.shipping_address?.contacts[0]?.phoneCode || !userdata?.shipping_address?.contacts[0]?.number) {
                setErrormessage((state) => ({
                    ...state,
                    'contacts': 'Contacts is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'contacts': ''
                }))
            }
        }
        if (!passval) {
            setFromshow(true)
            return;
        }
        if (changeshipping) {
            if (!userdata?.shipping_method?.shiptohome) {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': 'Shipping method is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': ''
                }))
            }
        } else {
            if (!userdata?.shipping_method?.storepick) {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': 'Shipping method is required'
                }))
                passval = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'shipping_method': ''
                }))
            }
        }
        if (passval) {
            setFromstaps({ one: false, two: true, three: false })
        }
        
    }
    const validationfunsecound = (userdata) => {
        // setFromstaps({ one: false, two: false, three: true });
        // navigate('/confirmpurchase', { state: userdata, lastpagedata: lastpagedata, countrylist: countrylist, shippinglist: shippinglist })

        let fromisvalid = true;
        if (!addressdata?.billingAddress?.length) {
            if (!userdata?.billingaddress?.fname) {
                setErrormessage((state) => ({
                    ...state,
                    'billingfname': 'First Name is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingfname': ''
                }))
            }
            if (!userdata?.billingaddress?.lname) {
                setErrormessage((state) => ({
                    ...state,
                    'billinglname': 'Last Name is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billinglname': ''
                }))
            }
            if (!userdata?.billingaddress?.address) {
                setErrormessage((state) => ({
                    ...state,
                    'billingaddress': 'Address is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingaddress': ''
                }))
            }
            if (!userdata?.billingaddress?.country?.value) {
                setErrormessage((state) => ({
                    ...state,
                    'billingcountry': 'Country is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingcountry': ''
                }))
            }
            if (!userdata?.billingaddress?.state) {
                setErrormessage((state) => ({
                    ...state,
                    'billingstate': 'State is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingstate': ''
                }))
            }
            if (!userdata?.billingaddress?.city) {
                setErrormessage((state) => ({
                    ...state,
                    'billingcity': 'City is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingcity': ''
                }))
            }
            if (!userdata?.billingaddress?.zipcode) {
                setErrormessage((state) => ({
                    ...state,
                    'billingzipcode': 'Zipcode is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingzipcode': ''
                }))
            }
            if (!userdata?.billingaddress?.contacts[0]?.number) {
                setErrormessage((state) => ({
                    ...state,
                    'billingcontacts': 'Contacts is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingcontacts': ''
                }))
            }
            if (!userdata?.billingaddress?.emails[0]) {
                setErrormessage((state) => ({
                    ...state,
                    'billingemails': 'Email is required'
                }))
                fromisvalid = false;
            } else if (!isValidEmail(userdata?.billingaddress?.emails[0])) {
                setErrormessage((state) => ({
                    ...state,
                    'billingemails': 'Invalid Email'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'billingemails': ''
                }))
            }
            if (!fromisvalid) {
                setBillingaddress(false)
            }
            if (!userdata?.agree) {
                setErrormessage((state) => ({
                    ...state,
                    'privacy': 'Select privacy is required'
                }))
                fromisvalid = false;
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'privacy': ''
                }))
            }
            // console.log(creditpaymentdata, "check Paymentmethod_type");
            // console.log(creditpaymentdata?.Paymentmethod_type, "check Paymentmethod_type");

            if (!creditpaymentdata?.Paymentmethod_type) {
                setErrormessage((state) => ({
                    ...state,
                    'payment': 'Pleace select payment method is required'
                }))
                fromisvalid = false;
            } else {
                if (creditpaymentdata?.Paymentmethod_type === "Bank" && creditpaymentdata?.payment_slag !== "paypal-payment" && creditpaymentdata?.payment_slag !== "cregis-payment") {
                    if (!userdata?.paymentMethod?.IB?.name) {
                        setErrormessage((state) => ({
                            ...state,
                            'payment': 'Pleace select bank is required'
                        }))
                        fromisvalid = false;
                    } else {
                        setErrormessage((state) => ({
                            ...state,
                            'payment': ''
                        }))
                    }
                    if (!userdata?.paymentMethod?.IB?.image) {
                        setErrormessage((state) => ({
                            ...state,
                            'payment': 'Upload evidence of transfer required'
                        }))
                        fromisvalid = false;
                    } else {
                        setErrormessage((state) => ({
                            ...state,
                            'payment': ''
                        }))
                    }
                }

                if (creditpaymentdata?.stripekey) {
                    setUserdata((state) => ({
                        ...state,
                        paymentMethod: {
                            paymentID: creditpaymentdata?.stripekey,
                            paymentMethodId: creditpaymentdata?.PaymentMethod,
                        }
                    }))
                    fromisvalid = true;
                } else {
                    setErrormessage((state) => ({
                        ...state,
                        'payment': creditpaymentdata?.message
                    }))
                    fromisvalid = false;
                }


            }
        }
        // console.log(fromisvalid, "FinelSubmit", creditpaymentdata);
        if (fromisvalid) {
            setCreditpaymentdata((state) => ({
                ...state,
                submitdata: true
            }))
            // navigate('/confirmpurchase', { state: userdata, lastpagedata: lastpagedata, countrylist: countrylist, shippinglist: shippinglist })
        }

    }


    const CompletedPaymentAndOrderAFterStepMove = async () => {
        setFromstaps({ one: false, two: false, three: true })
        let setupdatearray = [...state?.checkoutItems]
        const newArray1 = cartdata.filter((obj1) => !setupdatearray.some((obj2) => obj2.id === obj1.id));
        localStorage.setItem('CartItems', JSON.stringify(newArray1));
    }

    useEffect(() => {
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "paypal-payment") {
            saveorder();
        }
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "stripe-payment") {
            saveorder();
        }
        if (creditpaymentdata?.payment && creditpaymentdata?.payment_slag === "cregis-payment") {
            saveorder();
        }
        // eslint-disable-next-line
    }, [creditpaymentdata?.payment, creditpaymentdata?.payment_slag])


    const getpayment = async () => {
        try {
            let postdata = {}
            let res = await _Api(postdata, `checkout/get-payment`)
            if (res?.statusCode === 200) {
                setPaymentdata({
                    Bank: res?.data?.Bank ? res?.data?.Bank : [],
                    Credit_Card: res?.data?.Credit_Card ? res?.data?.Credit_Card : []
                })
                setPaymentgetwaydata(res?.paymetpaylist)
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
    useEffect(() => {
        getcountry();
        getshippings();
        getpayment()
    }, []);

    useEffect(() => {
        // console.log(addressdata, "address data here")
        const Dateoption = [...new Array(31)].map((each, index) => ({
            label: index + 1,
            value: index + 1,
        }));
        setDobvalues((state) => ({
            ...state,
            date: Dateoption
        }));
        const monthoption = [
            {
                value: 1,
                label: "JAN",
            },
            {
                value: 2,
                label: "FEB",
            },
            {
                value: 3,
                label: "MAR",
            },
            {
                value: 4,
                label: "APR",
            },
            {
                value: 5,
                label: "MAY",
            },
            {
                value: 6,
                label: "JUN",
            },
            {
                value: 7,
                label: "JUL",
            },
            {
                value: 8,
                label: "AUG",
            },
            {
                value: 9,
                label: "SEP",
            },
            {
                value: 10,
                label: "OCT",
            },
            {
                value: 11,
                label: "NOV",
            },
            {
                value: 12,
                label: "DEC",
            },

        ]
        setDobvalues((state) => ({
            ...state,
            month: monthoption
        }));
        const current = new Date();
        const lastyear = current.getFullYear() - 5;
        const firstyear = lastyear - 50;
        const yearoption = [...new Array(lastyear - firstyear + 2)]
            .fill()
            .map((_, idx) => ({ label: firstyear + idx, value: firstyear + idx }));
        setDobvalues((state) => ({
            ...state,
            year: yearoption
        }));
        if (accessToken) {
            getuserdetails(monthoption);
            setFromshow(false)
        }
        // eslint-disable-next-line
    }, []);


    const saveorder = async () => {

        let array = [...state?.checkoutItems]
        array.forEach((result) =>
            delete result?.price
        )
        let obj = { ...userdata }
        let usershipping_addressobj = { ...obj?.shipping_address }
        if (usershipping_addressobj?.date_of_birth?.month?.value) {
            usershipping_addressobj.date_of_birth.month = userdata?.shipping_address?.date_of_birth?.month?.value
        }
        let userbilling = { ...obj?.billingaddress }
        if (userbilling?.date_of_birth?.month?.value) {
            userbilling.date_of_birth.month = userdata?.billingaddress?.date_of_birth?.month?.value
        }
        usershipping_addressobj.country = userdata?.shipping_address?.country?.value
        userbilling.country = userdata?.billingaddress?.country?.value

        if (creditpaymentdata?.stripekey) {
            obj.paymentMethod = {
                paymentID: creditpaymentdata?.stripekey,
                paymentMethodId: creditpaymentdata?.PaymentMethod,
            }
        }
        setLodaer(true);
        // console.log(array, "DEEPAK SAVE FORM");

        try {
          
            let postdata = {
                customer_id: obj?.customer_id ? obj?.customer_id : "",
                cart: array,
                shipping_method: obj?.shipping_method,
                shipping_address: usershipping_addressobj,
                paymentMethod: obj?.paymentMethod,
                default_billing: obj?.default_billing ? obj?.default_billing : false,
                billing_address: userbilling
            }
            let res = await _Api(postdata, `checkout/placeOrder`)
            if (res?.statusCode === 200) {
                setLastpagedata(res)
                // setShippinglist([])
                
                setLodaer(false)
                CompletedPaymentAndOrderAFterStepMove();
                // setCreditpaymentdata((state) => ({
                //     ...state,
                //     submitdata: true
                // }))
            } else {
                setErrormessage((state) => ({
                    ...state,
                    'ordererror': res?.message
                }))
                setLodaer(false)
            }
        }
        catch (err) {
            setLodaer(false)
            console.log(err, "err")
            setErrormessage((state) => ({
                ...state,
                'ordererror': err?.response?.data?.message,
            }))
        }
    }


    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(email);
    };



    const handlePrivacyPolicy = () => {
        setPrivacyPolicy(!privacyPolicy);
        if (errormessage?.privacyPolicy && privacyPolicy) {
            setErrormessage((state) => ({ ...state, privacyPolicy: '' }))
        }
    }

    const CopyBillingAddresstoShippingAddress = (e) => {
        if (e.target.checked) {
            // console.log(userdata?.shipping_address, "both addresses", userdata?.billingaddress);
            setUserdata((state) => ({ ...state, shipping_address: userdata?.billingaddress }));
            setCopytoShipping(true);
        } else {
            setCopytoShipping(false)
        }
    }

    return (
        <>
            <div className="shippingpage ecommerce-main-layout-bodyContent">
                {state?.checkoutItems?.length ?
                    <>

                        <div className="shippingpage-title ">
                            <span onClick={() => navigate(-1)} className="cursor-pointer"> {t("Home")}</span><span><RightArrow /></span><span className="current">{("Checkout")}</span>
                        </div>
                        <div className="shippingpage-subTitle ">
                            <div className="shippingpage-subTitle-header" onClick={() => navigate(-1)}><LeftIcon /> <span> {t("Return to cart")} </span></div>
                            <div className="shippingpage-subTitle-title" onClick={() => navigate(-1)}>{t("Checkout")}</div>
                        </div>
                        <div className="shippingpage-bothSideBox">
                            <form id="shippingStepform" className="shipping-step-mainForm">
                                <div className="shippingpage-title responsive">
                                    <span onClick={() => navigate(-1)} className="cursor-pointer"> {t("Home")}</span><span><RightArrow /></span><span className="current">{("Checkout")}</span>
                                </div>
                                <div className="shippingpage-subTitle responsive">
                                    <div className="shippingpage-subTitle-header" onClick={() => navigate(-1)}><LeftIcon /> <span> {t("Return to cart")} </span></div>
                                    <div className="shippingpage-subTitle-title" onClick={() => navigate(-1)}>{t("Checkout")}</div>
                                </div>
                                <div className="shippingpage-bothSideBox-leftSide shipping">
                                    {!accessToken ?
                                        <div className="shipping-alertBox">
                                            <p className="shipping-alertBox-paraAlert">{t("Already a member")}?{" "} <span
                                                onClick={() => {
                                                    setOpenmodal(prevState => ({
                                                        ...prevState,
                                                        showLoginModel: true,
                                                        showRegisterModel: false,
                                                        showemailvarifymodal: false,
                                                        forgetpassword: false,
                                                        resetpassword: false,
                                                        newpassword: false
                                                    }))
                                                }}> {t("Sign-in")}</span> {t("for faster checkout")} </p>
                                            <p className="shipping-alertBox-paraAlert">{t("Don’t have an account")}? <span
                                                onClick={() => {
                                                    setOpenmodal(prevState => ({
                                                        ...prevState,
                                                        showLoginModel: false,
                                                        showRegisterModel: true,
                                                        showemailvarifymodal: false,
                                                        forgetpassword: false,
                                                        resetpassword: false,
                                                        newpassword: false
                                                    }))
                                                }}>{t("Create Account")}</span></p>
                                        </div>
                                        : ''}
                                    {/* <div className="shippingpage-subTitle responsive">
                                <div className="shippingpage-subTitle-header"><span className="rightarrow cursor-pointer" onClick={()=>navigate(-1)}><RightArrow/></span> <CheckoutBucketIcon/> {t("Checkout")} </div>
                                <div className="shippingpage-subTitle-subheader">{t("Shipping, taxes, and discounts at checkout")}</div>
                                </div> */}

                                    <div className="navigation-lineBox">
                                        <ul className="navigation-lineBox-container" id="progressbar">
                                            <li className="position-relative" id="account">

                                                <div className="navigation-lineBox-container-firstStartBox active">
                                                    <span className="com-nav-lightPointers ">{t("Shipping")}</span>
                                                    <div className="com-nav-lineShow"></div>
                                                </div>

                                                {/* <span className="navig-bottom-text active">{t("Shipping")}</span> */}
                                            </li>
                                            <li className="position-relative" id="personal">

                                                <div className={`navigation-lineBox-container-firstStartBox ${fromstaps?.two || fromstaps?.three ? "active" : ""}`}>
                                                    <span className="com-nav-lightPointers middle"><GreenTick color="#fff" /> </span>
                                                    <div className="com-nav-lineShow"></div>
                                                </div>
                                            </li>
                                            <li className="position-relative" id="payment">

                                                <div className={`navigation-lineBox-container-firstStartBox ${fromstaps?.three ? "active" : ""} `}>
                                                    <span className="com-nav-lightPointers ">{t("Payment")}</span>
                                                    <div className="com-nav-lineShow"></div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div></div>
                                    </div>

                                    <div className="shipping-step-mainForm-Container">
                                        {fromstaps?.one ?
                                            <fieldset className="shipping-step-mainForm-Container-fieldsetBox">

                                                <div className="shipping-addressFromBox">
                                                    {/* {console.log(shippingmethod, 'these are the methods')} */}
                                                    {shippingmethod?.shiptohome?.length || shippingmethod?.storepickup?.length ?
                                                        <div className="shipping-addressFromBox-shipngMethodBox">
                                                            <div className="shipping-addressFromBox-shipngMethodBox-headingMain">{t("Delivery Options")}</div>
                                                            <div className="shipping-addressFromBox-shipngMethodBox-selectMethod">
                                                                {shippingmethod?.shiptohome?.length ?
                                                                    <div className={`shipping-addressFromBox-shipngMethodBox-selectMethod-item ${changeshipping ? 'active' : ''}`}>
                                                                        <div className="ecom-radiobtndark" >
                                                                            <input type="radio" className="ecom-radiobtndark-inputField" onChange={() => setChangeshipping(true)} id="shipHome" name="shippingOption" checked={changeshipping ? true : false} />
                                                                            <label className="ecom-radiobtndark-labeltext"
                                                                                htmlFor="shipHome"
                                                                            >
                                                                                {t("Ship to home")}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    : ""}
                                                                {shippingmethod?.storepickup?.length ?
                                                                    <div className={`shipping-addressFromBox-shipngMethodBox-selectMethod-item ${!changeshipping ? 'active' : ''}`}>
                                                                        <div className="ecom-radiobtndark" >
                                                                            <input type="radio" className="ecom-radiobtndark-inputField" onChange={() => setChangeshipping(false)} id="storePickup" name="shippingOption" checked={!changeshipping ? true : false} />
                                                                            <label className="ecom-radiobtndark-labeltext"
                                                                                htmlFor="storePickup"
                                                                            >
                                                                                {t("Store Pickup")}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    : ""}
                                                            </div>

                                                            {changeshipping ?
                                                                <>
                                                                    <div className="shipping-addressFromBox-shipngMethodBox-optionswrapper-heading">
                                                                        {t("Shipping Method")}
                                                                    </div>
                                                                    <div className="shipping-addressFromBox-shipngMethodBox-optionswrapper">
                                                                        {/* {console.log(shippingmethod, "and this is billing ", userdata)} */}
                                                                        {shippingmethod?.shiptohome?.length && Object.keys(userdata?.billingaddress || {}).length ? shippingmethod?.shiptohome.map((result, key) => {

                                                                            return (
                                                                                <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox" key={key}>
                                                                                    <div className={`shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard ${userdata?.shipping_method?.shiptohome === result?._id && changeshipping ? 'active' : ""}`} onClick={() => {
                                                                                        setChangeshipping(true);
                                                                                        setUserdata({ ...userdata, shipping_method: { shiptohome: result?._id } }); setShippingdata((state) => ({
                                                                                            ...state,
                                                                                            shipprice: result?.price
                                                                                        }));
                                                                                    }}>
                                                                                        <div className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-radioBox">
                                                                                            <div className="ecom-radiobtndark" >
                                                                                                <input type="radio" className="ecom-radiobtndark-inputField"
                                                                                                    id={result?._id + key} name="shiptohome"
                                                                                                    checked={userdata?.shipping_method?.shiptohome === result?._id && changeshipping}
                                                                                                />
                                                                                                <label className="ecom-radiobtndark-labeltext"
                                                                                                    htmlFor={result?._id + key}
                                                                                                >
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="shipping-addressFromBox-shipngMethodBox-homeDeliveryAddrBox-selectStandard-shippDetailsBox">
                                                                                            <div className="standardShipping-Show">
                                                                                                <p className="standardShipping-Show-headingText">{t(`${result?.type}`)}</p>
                                                                                                <p className="standardShipping-Show-arrivesText">{t(`${result?.description}`)}</p>
                                                                                            </div>
                                                                                            <h2 className="shippingCostAmt">{result?.formatted_price}</h2>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }) :
                                                                            <div className="shipping-addressFromBox-shipngMethodBox-optionswrapper-default">
                                                                                {t("Enter your shipping address to view available shipping methods.")}
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                </>
                                                                :

                                                                <div className="shippingAddresboxWrapCont">
                                                                    {shippingmethod?.storepickup?.length ? shippingmethod?.storepickup.map((result, key) => {
                                                                        const items = [];

                                                                        for (let key in result?.store_timeSchedule) {

                                                                            items.push(<> <div className="shipping-timeSetBox-singleDay" key={key}><p className="userShippAddressBox-contentBox-lightText"> {`${key}`}</p>
                                                                                <p className="userShippAddressBox-contentBox-lightText">{`${result?.store_timeSchedule[key]}`}</p></div></>)

                                                                        }

                                                                        return (
                                                                            <div className={`userShippAddressBox ${userdata?.shipping_method?.storepick === result?._id ? "active" : ""}`} key={key}
                                                                                onClick={() => {
                                                                                    setUserdata({ ...userdata, shipping_method: { storepick: result?._id } }); setShippingdata((state) => ({
                                                                                        ...state,
                                                                                        shipprice: 0
                                                                                    }))
                                                                                }}>
                                                                                <div className="userShippAddressBox-selectBox">
                                                                                    <div className="ecom-radiobtndark" >
                                                                                        <input type="radio"
                                                                                            className="ecom-radiobtndark-inputField" id={result?._id} name="selectAdd"
                                                                                            checked={userdata?.shipping_method?.storepick === result?._id}
                                                                                        />
                                                                                        <label className="ecom-radiobtndark-labeltext"
                                                                                            htmlFor={result?._id}
                                                                                        >
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="userShippAddressBox-imageBox">
                                                                                    <img src={result?.Location_image ? result?.Location_image : DefaultImage} alt="store" />
                                                                                </div>
                                                                                <div className="userShippAddressBox-contentBox">
                                                                                    <div>
                                                                                        <div className="userDetailShipp">
                                                                                            <h3 className="userShippAddressBox-contentBox-boldText">{result?.name}</h3>
                                                                                            <p className="userShippAddressBox-contentBox-paraText">{result?.store_Address}</p>
                                                                                        </div>
                                                                                        <div className="responsive">
                                                                                            <h3 className="userShippAddressBox-contentBox-boldText">{t("Phone number")}:</h3>
                                                                                            <p className="userShippAddressBox-contentBox-lightText">{result?.contacts}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                    {/* <div className="d-flex gap-1" >
                                                                                        <h3 className="userShippAddressBox-contentBox-boldText">{t("Store Hours")}</h3>
                                                                                        <p className="userShippAddressBox-contentBox-lightText"></p>
                                                                                    </div> */}
                                                                                    <div className="responsive">
                                                                                        <div className=" shipping-timeSetBox">
                                                                                            {items?.length ? items.map((result) => {
                                                                                                return (result)
                                                                                            }) : ''}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }) : ''}

                                                                </div>

                                                            }
                                                            {errormessage?.shipping_method ? <div className='text-danger'>{t(`${errormessage?.shipping_method}`)}</div> : ""}

                                                        </div> :
                                                        shippingmethod !== undefined ?
                                                            <div className="mt-5">
                                                                <div className="text-danger">{t("You Don’t have a shipping method")}</div>
                                                            </div> : ""
                                                    }

                                                    <div className="shipping-addressFromBox-billingAddrBox">

                                                        <div className="shipping-addressFromBox-billingAddrBox-form-header">
                                                            {t("Billing Address")}
                                                        </div>
                                                        {addressdata?.billing_address?.length ?
                                                            <div className="shipping-addressFromBox-billingAddrBox-container">
                                                                <section className="addresscollector">
                                                                    {addressdata?.billing_address?.map((address, i) => {
                                                                        return (
                                                                            <div className="addresscollector-individualBox">
                                                                                <div className="">
                                                                                    <div className="ecom-radiobtnShowBox" onClick={() =>{ handleSelectAddress(address, i);getFullAddress(address?.UDID)}}>
                                                                                        <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                            id={i + 'billingaddress'} name="billingaddress"
                                                                                            checked={activeAddress?.billing === i ? true : false}
                                                                                        />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext"
                                                                                            htmlFor={i + 'billingaddress'}></label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="addresscollector-individualBox-inner">
                                                                                    <div className="addresscollector-individualBox-inner-data">
                                                                                        <div className="addresscollector-individualBox-inner-data-title">{address?.name ? address?.name : ""}</div>
                                                                                        <div className="addresscollector-individualBox-inner-data-metadata">{address?.completeAddress ? address?.completeAddress : ''}</div>
                                                                                        <div className="addresscollector-individualBox-inner-data-metadata">{address?.phone ? address?.phone : ''}</div>
                                                                                        <div className="addresscollector-individualBox-inner-data-metadata">{address?.email ? address?.email : ''}</div>
                                                                                        <div className="addresscollector-individualBox-inner-data-metadata">{t("Tax ID")}: {address?.taxId ? address?.taxId : ''}</div>
                                                                                    </div>
                                                                                    <div className="addresscollector-individualBox-inner-actions">
                                                                                        {address?.is_default ?
                                                                                            <div className="addresscollector-individualBox-inner-actions-isdefault">
                                                                                                <span>{t("Default Billing Address")}</span>
                                                                                            </div>
                                                                                            : null}
                                                                                        <div className="addresscollector-individualBox-inner-actions-edit">
                                                                                            <span>{t("Edit")}</span>
                                                                                            <span><EditIcon /></span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </section>
                                                                <div className="shipping-addressFromBox-billingAddrBox-container-description cursor-pointer" onClick={() => { setAddNewAddress('billing'); setActiveAddress((state) => ({ ...state, billing: null })) }}>
                                                                    <span><PlusIcon /> </span><span>{t("Add Billing Address")}</span>
                                                                </div>
                                                            </div>
                                                            : null}
                                                        {fromshow || addNewAddress === 'billing' || !addressdata?.billing_address?.length ?
                                                            <form className="shipping-addressFromBox-billingAddrBox-form">
                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                    <div className="ecom-formInputBoxBasic">
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.fname ? 'active' : ''}`}>
                                                                            {t("First Name")} <span className="text-danger">*</span>
                                                                        </label>
                                                                        <input
                                                                            className={`ecom-formInputBoxBasic-input ${errormessage?.billingfname ? 'border-danger' : ''}`}
                                                                            value={userdata?.billingaddress?.fname ? userdata?.billingaddress?.fname : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, fname: e.target.value }
                                                                            })} />
                                                                        {errormessage?.billingfname ? <div className='text-danger'>{t(`${errormessage?.billingfname}`)}</div> : ""}
                                                                    </div>
                                                                    <div className="ecom-formInputBoxBasic">
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.lname ? 'active' : ''}`}>
                                                                            {t("Last Name")} <span className="text-danger">*</span>
                                                                        </label>
                                                                        <input
                                                                            className={`ecom-formInputBoxBasic-input ${errormessage?.billinglname ? 'border-danger' : ''}`}
                                                                            value={userdata?.billingaddress?.lname ? userdata?.billingaddress?.lname : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, lname: e.target.value }
                                                                            })} />
                                                                        {errormessage?.billinglname ? <div className='text-danger'>{t(`${errormessage?.billinglname}`)}</div> : ""}
                                                                    </div>
                                                                </div>
                                                                <div className="ecom-formInputBoxBasic">
                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.company ? "active" : ""}`}>
                                                                        {t("Company")}<span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        className={errormessage?.billingaddress ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                        value={userdata?.billingaddress?.company ? userdata?.billingaddress?.company : ""}
                                                                        disabled={userdata?.default_billing ? true : false}
                                                                        onChange={(e) => setUserdata({
                                                                            ...userdata,
                                                                            billingaddress: { ...userdata?.billingaddress, company: e.target.value }
                                                                        })}
                                                                    />
                                                                    {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                </div>
                                                                <div className="ecom-formInputBoxBasic">
                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.address ? "active" : ""}`}>
                                                                        {t("Address")}<span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        className={errormessage?.billingaddress ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                        value={userdata?.billingaddress?.address ? userdata?.billingaddress?.address : ""}
                                                                        disabled={userdata?.default_billing ? true : false}
                                                                        onChange={(e) => setUserdata({
                                                                            ...userdata,
                                                                            billingaddress: { ...userdata?.billingaddress, address: e.target.value }
                                                                        })}
                                                                    />
                                                                    {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                </div>
                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                    <div className="ecom-formInputBoxBasic">
                                                                        <label className={`ecom-formInputBoxBasic-dropdownlabel ${userdata?.billingaddress?.country ? "active" : ""}`}>
                                                                            {t("Country")} <span className="text-danger">*</span>
                                                                        </label>
                                                                        <Select
                                                                            options={countrylist}
                                                                            className={`${errormessage?.billingcountry ? "border-danger" : ""}`}
                                                                            height='46px'
                                                                            width='100%'
                                                                            value={userdata?.billingaddress?.country || null}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, country: e }
                                                                            })}
                                                                            isSearchable={false}
                                                                            classNamePrefix='newDropdown'
                                                                        />
                                                                        {errormessage?.billingcountry ? <div className='text-danger'>{t(`${errormessage?.billingcountry}`)}</div> : ""}
                                                                    </div>
                                                                    <div className="ecom-formInputBoxBasic">
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.state ? "active" : ""}`}>
                                                                            {t("Province/State")} <span className="text-danger">*</span>
                                                                        </label>
                                                                        <input
                                                                            className={errormessage?.billingstate ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                            value={userdata?.billingaddress?.state ? userdata?.billingaddress?.state : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, state: e.target.value }
                                                                            })} />
                                                                        {errormessage?.billingstate ? <div className='text-danger'>{t(`${errormessage?.billingstate}`)}</div> : ""}
                                                                    </div>
                                                                </div>
                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                    <div className='ecom-formInputBoxBasic'>
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.city ? "active" : ""}`}>{t("City")} <span className='text-danger'>*</span></label>
                                                                        <input
                                                                            className={errormessage?.billingcity ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                            value={userdata?.billingaddress?.city ? userdata?.billingaddress?.city : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, city: e.target.value }
                                                                            })} />
                                                                        {errormessage?.billingcity ? <div className='text-danger'>{t(`${errormessage?.billingcity}`)}</div> : ""}
                                                                    </div>
                                                                    <div className='ecom-formInputBoxBasic'>
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.zipcode ? "active" : ""}`}>{t("Zip Code")} <span className='text-danger'>*</span></label>
                                                                        <input
                                                                            className={errormessage?.billingzipcode ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                            value={userdata?.billingaddress?.zipcode ? userdata?.billingaddress?.zipcode : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) =>
                                                                                setUserdata({
                                                                                    ...userdata,
                                                                                    billingaddress: { ...userdata?.billingaddress, zipcode: e.target.value }
                                                                                })} />
                                                                        {errormessage?.billingzipcode ? <div className='text-danger'>{t(`${errormessage?.billingzipcode}`)}</div> : ""}
                                                                    </div>
                                                                </div>
                                                                <div className="ecom-formInputBoxBasic">
                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.taxId ? "active" : ""}`}>
                                                                        {t("Tax ID No")}. {t("Optional")}
                                                                    </label>
                                                                    <input
                                                                        className={errormessage?.billingaddress ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                        value={userdata?.billingaddress?.taxId ? userdata?.billingaddress?.taxId : ""}
                                                                        disabled={userdata?.default_billing ? true : false}
                                                                        onChange={(e) => setUserdata({
                                                                            ...userdata,
                                                                            billingaddress: { ...userdata?.billingaddress, taxId: e.target.value }
                                                                        })}
                                                                    />
                                                                    {errormessage?.billingaddress ? <div className='text-danger'>{t(`${errormessage?.billingaddress}`)}</div> : ""}
                                                                </div>
                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow">
                                                                    <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons">
                                                                        {userdata?.billingaddress?.contacts?.length ? userdata?.billingaddress?.contacts.map((result, key) => {
                                                                            return (
                                                                                <div className="d-flex align-items-end">
                                                                                    <div className={errormessage?.billingcontacts ? 'ecom-formInputBoxBasic-phontfieldinput border-danger' : 'ecom-formInputBoxBasic-phontfieldinput'}>
                                                                                        <div className='ecom-formInputBoxBasic' key={key}>
                                                                                            <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.contacts?.length ? "active" : ""}`}>{t("Phone Number")} <span className='text-danger'>*</span></label>
                                                                                            <div
                                                                                                className={`ecom-formInputBoxBasic-phontfield ${errormessage?.billingcontacts ? 'border-danger d-flex' : "d-flex"}`}>
                                                                                                <div className='selectError_border border-0'>
                                                                                                    <Select
                                                                                                        options={phonecodelist}
                                                                                                        className={``}
                                                                                                        classNamePrefix='newDropdown'
                                                                                                        value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                        onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number,false)
                                                                                                            // setUserdata({
                                                                                                            //     ...userdata,
                                                                                                            //     billingaddress: { ...userdata?.billingaddress, contacts: [{ icon: 1, phoneCode: e.value, number: result?.number }] }
                                                                                                            // })
                                                                                                            }
                                                                                                    />
                                                                                                </div>
                                                                                                <input
                                                                                                    type='number'
                                                                                                    className='numberfield'
                                                                                                    value={result?.number}
                                                                                                    onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value,false)
                                                                                                        // setUserdata({
                                                                                                        //     ...userdata,
                                                                                                        //     billingaddress: { ...userdata?.billingaddress, contacts: [{ icon: 1, phoneCode: result?.phoneCode, number: e.target.value }] }
                                                                                                        // })
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {key !== 0 || userdata?.billingaddress?.contacts?.length <= 1 ?
                                                                                        <>
                                                                                            <span className="phoneplusicon" onClick={(e) => setUserdata({ ...userdata, billingaddress: { ...userdata?.billingaddress, contacts: [...userdata?.billingaddress?.contacts, { icon: 1, phoneCode: "", number: "" }] } })}><PlusIcon /></span>
                                                                                           { key !== 0 ? <span className="phoneminusicon" onClick={() => RemoveBlock('contacts', key,false)}><MinusIcon /></span> : null}
                                                                                        </>
                                                                                        : ""}
                                                                                </div>
                                                                            )
                                                                        }) : ''}
                                                                        {errormessage?.billingcontacts ? <div className='text-danger'>{t(`${errormessage?.billingcontacts}`)}</div> : ""}




                                                                        {/* <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons-row" 
                                                                                            onClick={(e) =>
                                                                                                                            setUserdata({
                                                                                                                                ...userdata,
                                                                                                                                billingaddress: { ...userdata?.billingaddress, contacts: [...userdata?.billingaddress?.contacts, { icon: 1, phoneCode: "" , number: "" }] }
                                                                                                                            })}>
                                                                                           <span><PlusIcon/></span>  <span>{t("Add Phone Number")}</span>
                                                                                    </div> */}
                                                                    </div>
                                                                    {/* <div className='ecom-formInputBoxBasic'>
                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.emails[0] ? "active" : ""}`}>{t("Email")} <span className='text-danger'>*</span></label>
                                                                        <input
                                                                            className={errormessage?.billingemails ? 'ecom-formInputBoxBasic-input border-danger' : 'ecom-formInputBoxBasic-input'}
                                                                            value={userdata?.billingaddress?.emails[0] ? userdata?.billingaddress?.emails[0] : ""}
                                                                            disabled={userdata?.default_billing ? true : false}
                                                                            onChange={(e) => setUserdata({
                                                                                ...userdata,
                                                                                billingaddress: { ...userdata?.billingaddress, emails: [e.target.value] }
                                                                            })} />
                                                                        {errormessage?.billingemails ? <div className='text-danger'>{t(`${errormessage?.billingemails}`)}</div> : ""}
                                                                    </div> */}






                                    <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons ecom-formInputBoxBasic">
                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.billingaddress?.emails?.length ? "active" : ""}`}>{t("Email")} <span className='text-danger'>*</span></label>
                                                    {userdata?.billingaddress?.emails?.length ? userdata?.billingaddress?.emails?.map((result, key) => {
                                                        return (
                                                            <div key={key} className="d-flex align-items-end">
                                                                <input
                                                                    type='email'
                                                                    className={errormessage?.billingemails ? 'ecom-formInputBoxBasic-input border-danger w-100' : 'ecom-formInputBoxBasic-input w-100'}
                                                                    value={result}
                                                                     onChange={(e) => ChangeMultipleSelect(e.target.value, key, 'email', '',false)}
                                                                />
                                                                {userdata?.billingaddress?.emails?.length <= 1 && key === 0 ?
                                                                    <>
                                                                        <span className="phoneplusicon" onClick={() => AddRow('email',false)}><PlusIcon /></span>
                                                                    </>
                                                                    : ""}
                                                                {key !== 0 ?
                                                                    <>
                                                                        <span className="phoneplusicon" onClick={() => AddRow('email',false)}><PlusIcon /></span>
                                                                        <span className="phoneminusicon" onClick={() => RemoveBlock('email', key,false)}><MinusIcon /></span>
                                                                    </>
                                                                    : ""}
                                                            </div>
                                                        )
                                                    }) : ''}
                                                    {errormessage?.billingemails ? <div className='text-danger'>{t(`${errormessage?.billingemails}`)}</div> : ""}

                                                </div>








                                                                </div>
                                                                {/* <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                                <div className="ecom-darkcustomToggleCheck">
                                                                    <input type="checkbox" className="ecom-darkcustomToggleCheck-toogleInput"
                                                                        id="defaultbilling" name="shiphome" />
                                                                    <label htmlFor="defaultbilling" className="ecom-darkcustomToggleCheck-toggleLabel"></label>
                                                                </div>
                                                                <span >{t("Default Billing Address")}</span>
                                                                </div> */}

                                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                                                    {/* <div className="ecom-darkcustomToggleCheck">
                                                                                        <input type="checkbox" className="ecom-darkcustomToggleCheck-toogleInput"
                                                                                            id="defaultshipping" onChange={() =>{ setUserdata(prevState => ({
                                                                                                ...prevState,
                                                                                                is_default: prevState.is_default === 1 ? 0 : 1 
                                                                                            }))}}
                                                                                            checked={userdata?.is_default === 1 ? true : false}
                                                                                        />
                                                                                        <label htmlFor="defaultshipping" className={`ecom-darkcustomToggleCheck-toggleLabel ${userdata?.is_default === 1 ? 'sliderbuttonon' : ''}`}></label>
                                                                                    </div> */}
                                                                                     <div className="ecom-darkcustomToggleCheck">
                                                                                        <input type="checkbox" className="ecom-darkcustomToggleCheck-toogleInput"
                                                                                            id="defaultbilling" onChange={() =>{ 
                                                                                                setBillingaddressdata((state) => ({ ...state, is_default: billingaddressdata.is_default === 1 ? 0 : 1 }));
                                                                                            setUserdata((prev)=>{
                                                                                                return {...prev , 

                                                                                                    billingaddress:{...prev?.billingaddress , is_default: prev?.billingaddress?.is_default === 0 ? 1 : 0}
                                                                                                }

                                                                                            })
                                                                                            console.log(userdata,'test changes in billing is_default')
                                                                                            }}
                                                                                            checked={userdata?.billingaddress?.is_default === 1 ? true : false}
                                                                                        />
                                                                                        <label htmlFor="defaultbilling" className={`ecom-darkcustomToggleCheck-toggleLabel ${userdata?.billingaddress?.is_default === 1 ? 'sliderbuttonon' : ''}`}></label>
                                                                                    </div>
                                                                                    <span >{t("Default Billing Address")}</span>
                                                                                </div>
                                                            </form>
                                                            : null}
                                                        {/* } */}

                                                    </div>


                                                    {!addressdata?.shipping_address?.length ?
                                                        <div className={`shipping-addressFromBox-copyBox ${copytoShipping ? 'withborder' : ''}`}>
                                                            <div className="ecom-blackthemed-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="itemscheckbox"
                                                                    id="copybillingaddress"
                                                                    name="shiphome"
                                                                    onChange={CopyBillingAddresstoShippingAddress}
                                                                    checked={copytoShipping}
                                                                />
                                                                <label className="ecom-blackthemed-checkbox-label" htmlFor='copybillingaddress'></label>
                                                            </div>
                                                            {/* <div className="ecom-radiobtnShowBox" >
                                                                                        <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                            id="copybillingaddress" name="shiphome"
                                                                                            onChange={CopyBillingAddresstoShippingAddress}
                                                                                        />
                                                                                        <label className="ecom-radiobtnShowBox-labeltext"
                                                                                            htmlFor="copybillingaddress"></label>
                                                                                    </div> */}
                                                            <div className="shipping-addressFromBox-copyBox-text">{t("Ship address same as billing address")}.</div>
                                                        </div>
                                                        : null}


                                                    {/* first tab shipping section */}
                                                    {!copytoShipping ?
                                                        <>
                                                            <div className="shipping-addressFromBox-headBox d-flex">
                                                                <h3 className="shipping-addressFromBox-billingAddrBox-form-header">{t("Shipping Address")}</h3>

                                                            </div>
                                                            {addressdata?.shipping_address?.length ?
                                                                <div className="shipping-addressFromBox-billingAddrBox-container">
                                                                    <section className="addresscollector">
                                                                        {addressdata?.shipping_address?.map((address, i) => {
                                                                            return (
                                                                                <div className="addresscollector-individualBox">
                                                                                    <div className="">
                                                                                        <div className="ecom-radiobtnShowBox" onClick={() => {  setActiveAddress((state) => ({ ...state, shipping: i }));getFullAddress(address?.UDID,false) }}>
                                                                                            <input type="radio" className="ecom-radiobtnShowBox-inputField"
                                                                                                id={i + 'shippingaddress'} name="shiphome"
                                                                                                checked={activeAddress?.shipping === i ? true : false}
                                                                                            />
                                                                                            <label className="ecom-radiobtnShowBox-labeltext"
                                                                                                htmlFor={i + 'shippingaddress'}></label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="addresscollector-individualBox-inner">
                                                                                        <div className="addresscollector-individualBox-inner-data">
                                                                                            <div className="addresscollector-individualBox-inner-data-title">{address?.name ? address?.name : ""}</div>
                                                                                            <div className="addresscollector-individualBox-inner-data-metadata">{address?.completeAddress ? address?.completeAddress : ''}</div>
                                                                                            <div className="addresscollector-individualBox-inner-data-metadata">{address?.phone ? address?.phone : ''}</div>
                                                                                            <div className="addresscollector-individualBox-inner-data-metadata">{address?.email ? address?.email : ''}</div>
                                                                                            <div className="addresscollector-individualBox-inner-data-metadata">{t("Tax ID")}: {address?.taxId ? address?.taxId : ''}</div>
                                                                                        </div>
                                                                                        <div className="addresscollector-individualBox-inner-actions">
                                                                                            {address?.is_default ?
                                                                                                <div className="addresscollector-individualBox-inner-actions-isdefault">
                                                                                                    <span>{t("Default Billing Address")}</span>
                                                                                                </div>
                                                                                                : null}
                                                                                            <div className="addresscollector-individualBox-inner-actions-edit">
                                                                                                <span>{t("Edit")}</span>
                                                                                                <span><EditIcon /></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </section>
                                                                    <div className="shipping-addressFromBox-billingAddrBox-container-description cursor-pointer" onClick={() => { setAddNewAddress('shipping'); setActiveAddress((state) => ({ ...state, shipping: null })) }}>
                                                                        <span><PlusIcon /> </span><span>{t("Add Shipping Address")}</span>
                                                                    </div>
                                                                </div>
                                                                : null}

                                                            <>

                                                                {fromshow || addNewAddress === 'shipping' || !addressdata?.shipping_address?.length ?
                                                                    <div className='addAdressBox-formBody'>
                                                                        <div className='addAdressBox-formBody-stepfirst'>
                                                                            <div className='addAdressBox-formBody-nameBox'>

                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.fname ? 'active' : ''}`}>{t("First Name")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.fname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.fname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                fname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.fname ? <div className='text-danger'>{t(`${errormessage?.fname}`)}</div> : ""}
                                                                                </div>
                                                                                {/* <div className='ecom-formInputBoxBasic'>
                                                                                    <label className=''>{t("Middle Name")}</label>
                                                                                    <input
                                                                                        className='form-control'
                                                                                        value={userdata?.shipping_address?.mname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                mname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                </div> */}
                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.lname ? 'active' : ''}`}>{t("Last Name")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.lname ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.lname}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                lname: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.lname ? <div className='text-danger'>{t(`${errormessage?.lname}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='ecom-formInputBoxBasic'>
                                                                                <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.company ? 'active' : ''}`}>{t("Company")} <span className='text-danger'>*</span></label>
                                                                                <input
                                                                                    className={`ecom-formInputBoxBasic-input ${errormessage?.company ? 'border-danger' : ''}`}
                                                                                    value={userdata?.shipping_address?.company}
                                                                                    onChange={(e) => setUserdata({
                                                                                        ...userdata,
                                                                                        shipping_address: {
                                                                                            ...userdata?.shipping_address,
                                                                                            company: e.target.value
                                                                                        }
                                                                                    })} />
                                                                                {errormessage?.company ? <div className='text-danger'>{t(`${errormessage?.company}`)}</div> : ""}
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.address ? 'active' : ''}`}>{t("Address")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.address ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.address}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                address: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.address ? <div className='text-danger'>{t(`${errormessage?.address}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox fullscreen-select'>
                                                                                <div className='ecom-formInputBoxBasic'>

                                                                                    <label className={`ecom-formInputBoxBasic-dropdownlabel ${userdata?.shipping_address?.country ? 'active' : ''}`}>{t("Country")} <span className='text-danger'>*</span></label>
                                                                                    <div className={errormessage?.country ? 'selectError_border border-danger' : 'selectError_border'
                                                                                    }
                                                                                    >
                                                                                        <Select
                                                                                            className={`${errormessage?.country ? 'border-danger' : ''}`}
                                                                                            options={countrylist}
                                                                                            value={userdata?.shipping_address?.country}
                                                                                            onChange={(e) => setUserdata({
                                                                                                ...userdata,
                                                                                                shipping_address: {
                                                                                                    ...userdata?.shipping_address,
                                                                                                    country: e
                                                                                                }
                                                                                            })}
                                                                                            classNamePrefix="newDropdown"
                                                                                            isSearchable={widtth > 560 ? true : false}
                                                                                        />
                                                                                    </div>
                                                                                    {errormessage?.country ? <div className='text-danger'>{t(`${errormessage?.country}`)}</div> : ""}
                                                                                </div>

                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.state ? 'active' : ''}`}>{t("Province/State")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.state ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.state}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                state: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.state ? <div className='text-danger'>{t(`${errormessage?.state}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.city ? 'active' : ''}`}>{t("City")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.city ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.city}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                city: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.city ? <div className='text-danger'>{t(`${errormessage?.city}`)}</div> : ""}
                                                                                </div>
                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.zipcode ? 'active' : ''}`}>{t("Zip Code")} <span className='text-danger'>*</span></label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.zipcode ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.zipcode}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                zipcode: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.zipcode ? <div className='text-danger'>{t(`${errormessage?.zipcode}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox'>
                                                                                <div className='ecom-formInputBoxBasic'>
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.taxId ? 'active' : ''}`}>{t("Tax ID no. (optional)")}</label>
                                                                                    <input
                                                                                        className={`ecom-formInputBoxBasic-input ${errormessage?.taxId ? 'border-danger' : ''}`}
                                                                                        value={userdata?.shipping_address?.taxId}
                                                                                        onChange={(e) => setUserdata({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address,
                                                                                                taxId: e.target.value
                                                                                            }
                                                                                        })} />
                                                                                    {errormessage?.taxId ? <div className='text-danger'>{t(`${errormessage?.taxId}`)}</div> : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div className='addAdressBox-formBody-nameBox align-items-start'>
                                                                                {/* <div className='ecom-formInputBoxBasic'>
                                                                                    <label className=''>{t("Contact")} <span className='text-danger'>*</span></label>
                                                                                    <div className='form-phoneAddContainer'>
                                                                                        {userdata?.shipping_address?.contacts?.length ? userdata?.shipping_address?.contacts.map((result, key) => {
                                                                                            return (
                                                                                                <>


                                                                                                    <div className="d-flex align-items-start w-100" key={key}>
                                                                                                        <div
                                                                                                            // className={errormessage?.contacts ? 'formBox-withMinusBtn border-danger' : 'formBox-withMinusBtn '}
                                                                                                            className={errormessage?.contacts ? 'd-flex align-items-start border border-danger rounded w-100' : "d-flex align-items-start border rounded w-100"}
                                                                                                        >
                                                                                                            <div className='selectError_border w-50 border-0'>
                                                                                                                <Select
                                                                                                                    options={phonecodelist}
                                                                                                                    className="ecommerce-dropdown w-100"
                                                                                                                    classNamePrefix="common-select"
                                                                                                                    value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number)}
                                                                                                                />
                                                                                                            </div>
                                                                                                            <div className="d-grid w-100">

                                                                                                                <div className="d-flex align-items-center">
                                                                                                                    <input
                                                                                                                        type='number'
                                                                                                                        className='form-control border-0'
                                                                                                                        value={result?.number}
                                                                                                                        onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value)}
                                                                                                                    />
                                                                                                                </div>


                                                                                                            </div>
                                                                                                        </div>
                                                                                                        {key !== 0 ? <span className='formBox-withMinusBtn-removebtn handleIcon ms-2 mt-2' onClick={() => RemoveBlock('contacts', key)}><MinusIcon /></span> : ''}
                                                                                                    </div>
                                                                                                    {errormessage?.contacts ? <div className='text-danger'>{t(`${errormessage?.contacts}`)}</div> : ""}
                                                                                                </>
                                                                                            )
                                                                                        }) : ''}

                                                                                        <div className='com-addFormItem-box'>
                                                                                            <div className='com-addFormItem-box-inner' onClick={() => AddRow('contacts')}>
                                                                                                <span className='d-flex'><PlusIcon width={16} height={16} color={'#1CACAC'} /></span>
                                                                                                {t("Add contacts")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}

                                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons">
                                                                                    {userdata?.shipping_address?.contacts?.length ? userdata?.shipping_address?.contacts.map((result, key) => {
                                                                                        return (
                                                                                            <div className="d-flex align-items-end">
                                                                                                <div className={errormessage?.contacts ? 'ecom-formInputBoxBasic-phontfieldinput border-danger' : 'ecom-formInputBoxBasic-phontfieldinput'}>
                                                                                                    <div className='ecom-formInputBoxBasic' key={key}>
                                                                                                        <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.contacts?.length ? "active" : ""}`}>{t("Phone Number")} <span className='text-danger'>*</span></label>
                                                                                                        <div
                                                                                                            className={`ecom-formInputBoxBasic-phontfield ${errormessage?.contacts ? 'border-danger d-flex' : "d-flex"}`}>
                                                                                                            <div className='tpfouradjustment selectError_border border-0'>
                                                                                                                <Select
                                                                                                                    options={phonecodelist}
                                                                                                                    className={``}
                                                                                                                    classNamePrefix='newDropdown'
                                                                                                                    value={{ 'label': result?.phoneCode, 'value': result?.phoneCode }}
                                                                                                                    onChange={(e) => ChangeMultipleSelect(e?.value, key, 'contacts', result?.number)}
                                                                                                                />
                                                                                                            </div>
                                                                                                            <input
                                                                                                                type='number'
                                                                                                                className='numberfield'
                                                                                                                value={result?.number}
                                                                                                                onChange={(e) => ChangeMultipleSelect(result?.phoneCode, key, 'contacts', e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {key !== 0 || userdata?.shipping_address?.contacts?.length <= 1 ?
                                                                                                    <>
                                                                                                        <span className="phoneplusicon" onClick={() => AddRow('contacts')}><PlusIcon /></span>
                                                                                                        { key !== 0 ?<span className="phoneminusicon" onClick={() => RemoveBlock('contacts', key)}><MinusIcon /></span>: null}
                                                                                                    </>
                                                                                                    : ""}
                                                                                            </div>
                                                                                        )
                                                                                    }) : ''}
                                                                                    {errormessage?.contacts ? <div className='text-danger'>{t(`${errormessage?.contacts}`)}</div> : ""}
                                                                                </div>
                                                                                {/* <div className='ecom-formInputBoxBasic'>
                                                                                    <label className=''>{t("Email")} <span className='text-danger'>*</span></label>
                                                                                    <div className='form-phoneAddContainer'>
                                                                                        {userdata?.shipping_address?.emails?.length ? userdata?.shipping_address?.emails?.map((result, key) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <div className='formBox-withMinusBtn border-0' key={key}>
                                                                                                        <input
                                                                                                            className={errormessage?.emails ? 'form-control border-danger' : 'form-control'}
                                                                                                            value={result} onChange={(e) => ChangeMultipleSelect(e.target.value, key, 'email', '')} />

                                                                                                        {key !== 0 ? <span className='formBox-withMinusBtn-removebtn handleIcon' onClick={() => RemoveBlock('email', key)}><MinusIcon /></span> : ''}
                                                                                                    </div>
                                                                                                    {errormessage?.emails ? <div className='text-danger'>{t(`${errormessage?.emails}`)}</div> : ""}
                                                                                                </>
                                                                                            );
                                                                                        }) : ''}

                                                                                        <div className='com-addFormItem-box'>
                                                                                            <div className='com-addFormItem-box-inner' onClick={() => AddRow('email')}>
                                                                                                <span className='d-flex'><PlusIcon width={16} height={16} color={'#1CACAC'} /></span>
                                                                                                {t("Add Email")}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div> */}
                                                                                <div className="shipping-addressFromBox-billingAddrBox-form-multifieldRow-addons ecom-formInputBoxBasic">
                                                                                    <label className={`ecom-formInputBoxBasic-label ${userdata?.shipping_address?.emails?.length ? "active" : ""}`}>{t("Email")} <span className='text-danger'>*</span></label>
                                                                                    {userdata?.shipping_address?.emails?.length ? userdata?.shipping_address?.emails?.map((result, key) => {
                                                                                        return (
                                                                                            <div key={key} className="d-flex align-items-end">
                                                                                                <input
                                                                                                    type='email'
                                                                                                    className={errormessage?.emails ? 'ecom-formInputBoxBasic-input border-danger w-100' : 'ecom-formInputBoxBasic-input w-100'}
                                                                                                    value={result} onChange={(e) => ChangeMultipleSelect(e.target.value, key, 'email', '')}
                                                                                                />
                                                                                                {userdata?.shipping_address?.emails?.length <= 1 && key === 0 ?
                                                                                                    <>
                                                                                                        <span className="phoneplusicon" onClick={() => AddRow('email')}><PlusIcon /></span>
                                                                                                    </>
                                                                                                    : ""}
                                                                                                {key !== 0 ?
                                                                                                    <>
                                                                                                        <span className="phoneplusicon" onClick={() => AddRow('email')}><PlusIcon /></span>
                                                                                                        <span className="phoneminusicon" onClick={() => RemoveBlock('email', key)}><MinusIcon /></span>
                                                                                                    </>
                                                                                                    : ""}
                                                                                            </div>
                                                                                        )
                                                                                    }) : ''}
                                                                                    {errormessage?.emails ? <div className='text-danger'>{t(`${errormessage?.emails}`)}</div> : ""}

                                                                                </div>
                                                                            </div>
                                                                            <div className="addAdressBox-formBody-radioSwitchBox">
                                                                                {/* <p className="addAdressBox-formBody-radioSwitchBox-textShow">{t("Default Shipping Address")}</p>
                                                                                <div className="com-customToggleCheck">
                                                                                    <input type="checkbox" id="togglebtn1" className="com-customToggleCheck-toogleInput"
                                                                                        defaultChecked={userdata?.shipping_address?.is_default ? true : false}
                                                                                        onChange={(e) => setUserdata((state) => ({
                                                                                            ...userdata,
                                                                                            shipping_address: {
                                                                                                ...userdata?.shipping_address, is_default: e.target.checked ? 1 : 0
                                                                                            }
                                                                                        }))} />
                                                                                    <label htmlFor="togglebtn1" className="com-customToggleCheck-toggleLabel"></label>
                                                                                </div> */}
                                                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper">
                                                                                    <div className="ecom-darkcustomToggleCheck">
                                                                                        <input type="checkbox" className="ecom-darkcustomToggleCheck-toogleInput"
                                                                                            id="defaultshipping" onChange={() =>{ 
                                                                                                // setBillingaddressdata((state) => ({ ...state, is_default: billingaddressdata.is_default === 1 ? 0 : 1 }));
                                                                                            setUserdata((prev)=>{
                                                                                                return {...prev , 

                                                                                                    shipping_address:{...prev?.shipping_address , is_default: prev?.shipping_address?.is_default === 0 ? 1 : 0}
                                                                                                }

                                                                                            })
                                                                                            console.log(userdata,'test changes in is_default')
                                                                                            }}
                                                                                            checked={userdata?.shipping_address?.is_default === 1 ? true : false}
                                                                                        />
                                                                                        <label htmlFor="defaultshipping" className={`ecom-darkcustomToggleCheck-toggleLabel ${userdata?.shipping_address?.is_default === 1 ? 'sliderbuttonon' : ''}`}></label>
                                                                                    </div>
                                                                                    <span >{t("Default Shipping Address")}</span>
                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                    :
                                                                    null
                                                                }
                                                            </>
                                                        </> : null}

                                                </div>

                                                {/* bottom content of first section */}


                                                <div className="ecom-darkthemed-checkbox ecom-checkbox-wrapper pt-4">
                                                    <div className="ecom-blackthemed-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            id="privacy-policy"
                                                            onChange={() => handlePrivacyPolicy()}
                                                            checked={privacyPolicy ? true : false}
                                                        />
                                                        <label className="ecom-blackthemed-checkbox-label" htmlFor='privacy-policy'></label>
                                                    </div>
                                                    <span className={`mobilefilter-inner-wrapper-content-filterdata-holder-label ${errormessage?.privacyPolicy ? 'text-danger' : ''}`}>{t("I accept the")}{" "}<span className="text-decoration-underline">{t("Privacy Policy")}</span>{" "}{t("and")}{" "}<span className="text-decoration-underline">{t("terms and conditions")}</span>.</span>
                                                </div>
                                                <div className="shipping-formBottom-btn">

                                                    <button type="button" className='themeBtn w-100'
                                                        onClick={() => validationfun(userdata)}>{t("Continue to payment")}</button>
                                                </div>
                                            </fieldset>
                                            // end of first tab

                                            :
                                            // start of second tab
                                            fromstaps?.two ?
                                                <fieldset className="shipping-step-mainForm-Container-fieldsetBox">
                                                    <div className="paymentStepPage">
                                                     {   <div className="paymentStepPage-addresscontainer">
                                                            <div className="paymentStepPage-addresscontainer-box">
                                                                <div className="paymentStepPage-addresscontainer-box-title">
                                                                    <span>{t("Billing Address")}</span>
                                                                    <span className="right"><EditIcon type='pencil' />{t("Change")}</span>
                                                                </div>
                                                                <div className="paymentStepPage-addresscontainer-box-details">
                                                                    <span className="dark">{userdata?.billingaddress?.company}</span>
                                                                    <span className="semibold">{userdata?.billingaddress?.address}</span>
                                                                    <span className="">{userdata?.billingaddress?.fname}{" "}{userdata?.billingaddress?.lname}{" "}(+{userdata?.billingaddress?.contacts[0]?.phoneCode}){userdata?.billingaddress?.contacts[0]?.number}</span>
                                                                    <span className="">{t("Tax ID")}:{" "}{userdata?.billingaddress?.taxId ? userdata?.billingaddress?.taxId : "-"}</span>
                                                                    <span className="">{t("Email")}:{" "}{userdata?.billingaddress?.emails[0]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="paymentStepPage-addresscontainer-box">
                                                                <div className="paymentStepPage-addresscontainer-box-title">
                                                                    <span>{t("Shipping Address")}</span>
                                                                    <span className="right"><EditIcon type='pencil' />{t("Change")}</span>
                                                                </div>
                                                                <div className="paymentStepPage-addresscontainer-box-details">
                                                                    <span className="dark">{userdata?.shipping_address?.company}</span>
                                                                    <span className="semibold">{userdata?.shipping_address?.address}</span>
                                                                    <span className="">{userdata?.shipping_address?.fname}{" "}{userdata?.shipping_address?.lname}{" "}(+{userdata?.shipping_address?.contacts[0]?.phoneCode}){userdata?.shipping_address?.contacts[0]?.number}</span>
                                                                    <span className="">{t("Tax ID")}:{" "}{userdata?.shipping_address?.taxId ? userdata?.shipping_address?.taxId : "-"}</span>
                                                                    <span className="">{t("Email")}:{" "}{userdata?.shipping_address?.emails[0]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="paymentStepPage-addresscontainer-box">
                                                                <div className="paymentStepPage-addresscontainer-box-title">
                                                                    <span>{t("Delivery Options")}</span>
                                                                    <span className="right"><EditIcon type='pencil' />{t("Change")}</span>
                                                                </div>
                                                                <div className="paymentStepPage-addresscontainer-box-details">
                                                                    <span className="">{userdata?.shipping_method?.shiptohome ? 'Ship to home' : userdata?.shipping_method?.storepick ? 'Ship to store' : ''}</span>
                                                                </div>
                                                            </div>
                                                        </div> 
}
                                                        <div className="shipping-addressFromBox paymentStepPage-main">

                                                            <div className="paymentStepPage-main-paymentMethodBox">
                                                                <div className="paymentStepPage-main-paymentMethodBox-headBox">
                                                                    <h3 className="com-shippingPage-headingMain mb-2 w-100">{t("Payment Method")}</h3>
                                                                    <h6 className="paymentStepPage-main-paymentMethodBox-headBox-sub">{t("All transactions are secure and encrypted")}.</h6>

                                                                </div>


                                                            </div>
                                                            {paymentgetwaydata?.length ?
                                                                <div className="paymentStepPage-main-paymentMethodBox">
                                                                    <PaymentTabs
                                                                        userdata={userdata}
                                                                        setUserdata={setUserdata}
                                                                        paymentgetwaydata={paymentgetwaydata}
                                                                        payamount={shippingdata?.shipprice ? shippingdata?.shipprice + shippinglist.reduce(
                                                                            (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                                            0
                                                                        ) : 0 + shippinglist.reduce(
                                                                            (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                                            0
                                                                        )}
                                                                        currency={shippingdata?.CURRENCY}
                                                                        setCreditpaymentdata={setCreditpaymentdata}
                                                                        creditpaymentdata={creditpaymentdata}
                                                                        alldata={{
                                                                            name: userdata?.billingaddress?.fname,
                                                                            email: userdata?.billingaddress?.emails[0]
                                                                        }} />

                                                                    {errormessage?.payment || creditpaymentdata?.message ? <div className="text-danger">
                                                                        {errormessage?.payment ? errormessage?.payment :
                                                                            creditpaymentdata?.message}</div> :
                                                                        ""}
                                                                </div> :
                                                                <div className="text-danger">
                                                                    {t("No payment method available. please contact with support team")}
                                                                </div>
                                                            }


                                                        </div>
                                                    </div>
                                                    {errormessage?.ordererror ? <div className="text-danger text-end">{t(`${errormessage?.ordererror}`)}</div> : ""}
                                                    <button type="button" className=' d-none com-ecomSendBtn shipping-continBtn previous' id="previous_btn" name="previous" value="Previous">{t("Pervious")}</button>
                                                    <div className="shipping-formBottom-btn">
                                                        {/* <div className='shipping-formBottom-btn-backCartBtnBox'><span className='arrowIconCart'><LeftSideArrowIcon width={16.71} height={16.71} /></span ><span className='cartBackShow'
                                                            onClick={() => setFromstaps({ one: true, two: false, three: false })} >
                                                            {t("Back")}</span></div> */}
                                                        {lodaer ?
                                                            <div className='com-ecomSendBtn themeBtn next w-100'>
                                                                <div className="border-bottom-0 border-width-2px text-white d-block mx-auto spinner-border flex-shrink-0" role="status"></div>
                                                            </div> :
                                                            <button type="button" className='themeBtn w-100' name="next" value="Next" id='firststep_2'
                                                                onClick={() => validationfunsecound(userdata)}>{t("Place Order")}</button>}
                                                    </div>
                                                </fieldset>
                                                // end of second tab 

                                                :

                                                <fieldset className="shipping-step-mainForm-Container-fieldsetBox">
                                                    <div className="confirmPurchasePage">
                                                        <ConfirmPage  lastpagedata={lastpagedata} countrylist={countrylist} shippinglist={shippinglist} shippingdata={shippingdata}/>
                                                    </div>
                                                </fieldset>
                                        }


                                    </div>
                                </div>
                            </form>

                            <div className="shippingpage-bothSideBox-rightSide">
                                <div className={`hiddentab ${isOpenOrder ? 'open' : 'bg-white'}`} onClick={toggleOrderSummary}>
                                    <div className="hiddentab-leftside">
                                        <CheckoutBucketIcon type='normal' />
                                        <div>
                                            {t("Order summary")} ({shippinglist?.length})
                                        </div>
                                    </div>
                                    <div className="hiddentab-rightside">
                                        <span className='hiddentab-contentText'>
                                            {toFormatPrice(shippinglist?.length ?
                                                shippingdata?.shipprice ? shippingdata?.shipprice + shippinglist.reduce(
                                                    (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                    0
                                                ) : shippinglist.reduce(
                                                    (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                                    0
                                                ) : 0 + 0, { addSymbol: true })}
                                        </span>
                                        <span className="hiddentab-rightside-arrow"><DownArrow /></span>
                                    </div>
                                </div>
                                <div id="shippingOrderSumm" className={isOpenOrder ? 'active' : ''}>
                                    <OrderSummery fromstaps={fromstaps} shippinglist={shippinglist} setShippinglist={setShippinglist} shippingdata={shippingdata} />
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        {navigate("/shoppingcart", { state: { shippingdata: [] } })}
                    </>}

            </div>
            {/* <ShippingAddrModel
                shipaddress={shipaddress}
                setShipaddress={setShipaddress}
                setUserdata={setUserdata}
                setFromshow={setFromshow}
                setBillingaddress={setBillingaddress}
                dobvalues={dobvalues} /> */}

        </>
    )
}
